/* Catalog Data matching Mockup with precise hex colors */
const PRODUCTS = {
  'prod-1': {
    id: 'prod-1',
    title: 'Mountain Essential Long Sleeve Tee',
    price: 49,
    type: 'long-sleeve',
    colors: [
      { name: 'Natural Sand', hex: '#EFE9DF' },
      { name: 'Olive Drab', hex: '#41483C' },
      { name: 'Deep Navy', hex: '#202735' },
      { name: 'Terracotta', hex: '#965538' }
    ],
    currentColor: 0,
    desc: 'Substantial 280 GSM organic combed cotton with ribbed wrist cuffs and reinforced neckline. Engineered to hold shape across hundreds of washes.'
  },
  'prod-2': {
    id: 'prod-2',
    title: 'The Homecoming Heavyweight Crewneck',
    price: 59,
    type: 'crewneck',
    colors: [
      { name: 'Heather Sand', hex: '#EFE9DF' },
      { name: 'Olive Green', hex: '#41483C' },
      { name: 'Deep Navy', hex: '#202735' },
      { name: 'Charcoal Black', hex: '#18191B' }
    ],
    currentColor: 2,
    desc: 'An enduring icon. 450 GSM French terry cotton woven with double-needle flatlock seams and classic pre-shrunk silhouette.'
  },
  'prod-3': {
    id: 'prod-3',
    title: 'Classic Daily Tee',
    price: 49,
    type: 'tee',
    colors: [
      { name: 'Bone White', hex: '#EFE9DF' },
      { name: 'Muted Olive', hex: '#41483C' },
      { name: 'Midnight Navy', hex: '#202735' },
      { name: 'Pitch Black', hex: '#18191B' }
    ],
    currentColor: 1,
    desc: 'Our most sought-after staple. Ultra-fine combed ring-spun jersey with an exceptionally soft hand-feel and crisp structured drape.'
  },
  'prod-4': {
    id: 'prod-4',
    title: 'Resort Cotton Tee',
    price: 49,
    type: 'tee',
    colors: [
      { name: 'Ecru Cream', hex: '#EFE9DF' },
      { name: 'Warm Terracotta', hex: '#965538' },
      { name: 'Dark Olive', hex: '#41483C' },
      { name: 'Deep Black', hex: '#18191B' }
    ],
    currentColor: 1,
    desc: 'Lightweight, breathable open-weave cotton with relaxed shoulder seams crafted for balmy coastal evenings and effortless layering.'
  }
};

const HERO_SLIDES = [
  {
    tag: 'THE MOUNTAIN ESSENTIAL',
    title: 'A refined<br>everyday essential,<br>made to be worn<br>on repeat.',
    desc: 'Substantial. Versatile. Timeless.<br>For a more considered life.',
    img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=1600&q=85'
  },
  {
    tag: 'THE COASTAL SWEATSHIRT',
    title: 'A refined<br>everyday essential,<br>made to be worn<br>on repeat.',
    desc: 'Substantial. Versatile. Timeless.<br>For a more considered life.',
    img: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=1600&q=85'
  },
  {
    tag: 'MINDFUL FOUNDATIONS',
    title: 'A refined<br>everyday essential,<br>made to be worn<br>on repeat.',
    desc: 'Substantial. Versatile. Timeless.<br>For a more considered life.',
    img: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&w=1600&q=85'
  }
];

let cart = [];
let currentSlide = 0;
let quickViewActiveId = null;
let selectedSize = 'M';

function generateGarmentSVG(type, hexColor) {
  if (type === 'long-sleeve') {
    return `
      <svg viewBox="0 0 200 240" class="w-4/5 h-auto filter drop-shadow-md" xmlns="http://www.w3.org/2000/svg">
        <g fill="${hexColor}" stroke="#191B1C" stroke-width="1.2" stroke-linejoin="round">
          <path d="M 70 38 L 22 85 L 36 96 L 68 76 L 66 215 L 134 215 L 132 76 L 164 96 L 178 85 L 130 38 Q 100 48 70 38 Z" />
          <path d="M 22 85 L 16 93 L 28 102 L 36 96 Z" fill="${hexColor}" stroke="#191B1C" stroke-width="1" />
          <path d="M 178 85 L 184 93 L 172 102 L 164 96 Z" fill="${hexColor}" stroke="#191B1C" stroke-width="1" />
          <line x1="66" y1="205" x2="134" y2="205" stroke="#191B1C" stroke-width="0.8" opacity="0.4"/>
          <path d="M 82 39 C 82 50 118 50 118 39 C 118 43 82 43 82 39" fill="none" stroke="#191B1C" stroke-width="1.4"/>
          <circle cx="112" cy="85" r="1.5" fill="#191B1C" opacity="0.25"/>
        </g>
      </svg>
    `;
  } else if (type === 'crewneck') {
    return `
      <svg viewBox="0 0 200 240" class="w-4/5 h-auto filter drop-shadow-md" xmlns="http://www.w3.org/2000/svg">
        <g fill="${hexColor}" stroke="#191B1C" stroke-width="1.2" stroke-linejoin="round">
          <path d="M 68 36 L 18 80 L 32 92 L 64 74 L 62 216 L 138 216 L 136 74 L 168 92 L 182 80 L 132 36 Q 100 46 68 36 Z" />
          <path d="M 18 80 L 12 88 L 24 98 L 32 92 Z" fill="${hexColor}" stroke="#191B1C" stroke-width="1" />
          <path d="M 182 80 L 188 88 L 176 98 L 168 92 Z" fill="${hexColor}" stroke="#191B1C" stroke-width="1" />
          <rect x="62" y="206" width="76" height="10" fill="${hexColor}" stroke="#191B1C" stroke-width="1" />
          <path d="M 78 37 C 78 52 122 52 122 37" fill="none" stroke="#191B1C" stroke-width="2.5"/>
          <path d="M 80 40 C 80 50 120 50 120 40" fill="none" stroke="#191B1C" stroke-width="1" stroke-dasharray="2,2" opacity="0.6"/>
          <circle cx="115" cy="84" r="1.8" fill="#191B1C" opacity="0.3"/>
        </g>
      </svg>
    `;
  } else {
    return `
      <svg viewBox="0 0 200 240" class="w-4/5 h-auto filter drop-shadow-md" xmlns="http://www.w3.org/2000/svg">
        <g fill="${hexColor}" stroke="#191B1C" stroke-width="1.2" stroke-linejoin="round">
          <path d="M 70 38 L 32 66 L 44 86 L 68 76 L 68 214 L 132 214 L 132 76 L 156 86 L 168 66 L 130 38 Q 100 48 70 38 Z" />
          <path d="M 82 39 C 82 50 118 50 118 39" fill="none" stroke="#191B1C" stroke-width="1.8"/>
          <path d="M 83 42 C 83 48 117 48 117 42" fill="none" stroke="#191B1C" stroke-width="0.8" opacity="0.5"/>
          <line x1="36" y1="78" x2="46" y2="84" stroke="#191B1C" stroke-width="0.8" opacity="0.4"/>
          <line x1="164" y1="78" x2="154" y2="84" stroke="#191B1C" stroke-width="0.8" opacity="0.4"/>
          <line x1="68" y1="206" x2="132" y2="206" stroke="#191B1C" stroke-width="0.8" opacity="0.4"/>
          <circle cx="112" cy="80" r="1.5" fill="#191B1C" opacity="0.25"/>
        </g>
      </svg>
    `;
  }
}

function renderProductGarments() {
  Object.keys(PRODUCTS).forEach(pid => {
    const prod = PRODUCTS[pid];
    const container = document.getElementById(`svg-display-${pid}`);
    if (container) {
      const activeHex = prod.colors[prod.currentColor].hex;
      container.innerHTML = generateGarmentSVG(prod.type, activeHex);
    }
  });
}

function setProductColor(pid, colorIdx) {
  const prod = PRODUCTS[pid];
  if (!prod) return;
  prod.currentColor = colorIdx;

  const container = document.getElementById(`svg-display-${pid}`);
  if (container) {
    container.style.opacity = '0.4';
    setTimeout(() => {
      container.innerHTML = generateGarmentSVG(prod.type, prod.colors[colorIdx].hex);
      container.style.opacity = '1';
    }, 120);
  }

  const card = document.querySelector(`[data-pid="${pid}"]`);
  if (card) {
    const buttons = card.querySelectorAll('.rounded-full');
    buttons.forEach((btn, idx) => {
      if (idx === colorIdx) {
        btn.classList.add('swatch-ring');
      } else {
        btn.classList.remove('swatch-ring');
      }
    });
  }
}

function switchHeroSlide(idx) {
  currentSlide = idx;
  const slide = HERO_SLIDES[idx];
  const title = document.getElementById('hero-title');
  const desc = document.getElementById('hero-desc');
  const tag = document.getElementById('hero-tag');
  const img = document.getElementById('hero-main-img');

  if (title) title.innerHTML = slide.title;
  if (desc) desc.innerHTML = slide.desc;
  if (tag) tag.innerText = slide.tag;
  if (img) {
    img.style.opacity = '0.7';
    setTimeout(() => {
      img.src = slide.img;
      img.style.opacity = '1';
    }, 150);
  }

  for (let i = 0; i < 3; i++) {
    const navBtn = document.getElementById(`hero-nav-${i}`);
    const indicator = document.getElementById(`indicator-${i}`);
    if (i === idx) {
      if (navBtn) navBtn.className = 'relative pb-2 text-brand-textPrimary transition-colors';
      if (indicator) indicator.classList.remove('hidden');
    } else {
      if (navBtn) navBtn.className = 'relative pb-2 hover:text-brand-textPrimary transition-colors text-stone-400';
      if (indicator) indicator.classList.add('hidden');
    }
  }
}

function openQuickView(pid) {
  const prod = PRODUCTS[pid];
  if (!prod) return;
  quickViewActiveId = pid;
  selectedSize = 'M';

  const activeColor = prod.colors[prod.currentColor];
  const body = document.getElementById('quickview-body');
  if (body) {
    body.innerHTML = `
      <div class="aspect-square bg-[#ECE6DC] p-8 flex items-center justify-center">
        <div id="qv-svg-container" class="w-full h-full flex items-center justify-center">
          ${generateGarmentSVG(prod.type, activeColor.hex)}
        </div>
      </div>
      <div>
        <div class="text-[10px] uppercase tracking-[0.25em] text-brand-terracotta font-semibold mb-1">LAVIESO ESSENTIAL</div>
        <h2 class="font-serif text-2xl sm:text-3xl text-brand-textPrimary mb-2 leading-tight">${prod.title}</h2>
        <p class="text-base font-semibold text-brand-textPrimary mb-4">$${prod.price}.00</p>
        <p class="text-xs text-brand-textMuted leading-relaxed mb-6">${prod.desc}</p>
        
        <div class="mb-4">
          <span class="block text-xs uppercase tracking-wider font-semibold text-brand-textPrimary mb-2">
            Color: <span id="qv-color-title" class="font-normal text-brand-textMuted">${activeColor.name}</span>
          </span>
          <div class="flex items-center space-x-2.5">
            ${prod.colors.map((c, i) => `
              <button onclick="setQVColor(${i})" class="w-5 h-5 rounded-full border border-stone-300 ${i === prod.currentColor ? 'swatch-ring' : ''}" style="background-color: ${c.hex};" title="${c.name}"></button>
            `).join('')}
          </div>
        </div>

        <div class="mb-6">
          <span class="block text-xs uppercase tracking-wider font-semibold text-brand-textPrimary mb-2">Size</span>
          <div class="grid grid-cols-4 gap-2 text-xs font-medium">
            ${['S', 'M', 'L', 'XL'].map(sz => `
              <button onclick="setQVSize('${sz}')" id="qv-btn-${sz}" class="py-2.5 border text-center transition-colors ${sz === 'M' ? 'border-brand-dark bg-brand-dark text-white' : 'border-brand-border bg-white text-brand-textPrimary hover:border-black'}">
                ${sz}
              </button>
            `).join('')}
          </div>
        </div>

        <button onclick="addCurrentQVToBag()" class="w-full bg-brand-dark hover:bg-black text-white text-xs uppercase tracking-widest py-3.5 font-medium transition-colors">
          ADD TO BAG • $${prod.price}.00
        </button>
      </div>
    `;
  }

  const backdrop = document.getElementById('quickview-backdrop');
  const panel = document.getElementById('quickview-panel');
  if (backdrop && panel) {
    backdrop.classList.remove('opacity-0', 'pointer-events-none');
    backdrop.classList.add('opacity-100');
    panel.classList.remove('scale-95');
    panel.classList.add('scale-100');
  }
}

function setQVColor(idx) {
  if (!quickViewActiveId) return;
  const prod = PRODUCTS[quickViewActiveId];
  prod.currentColor = idx;
  const activeColor = prod.colors[idx];
  
  const svgBox = document.getElementById('qv-svg-container');
  const label = document.getElementById('qv-color-title');
  if (svgBox) svgBox.innerHTML = generateGarmentSVG(prod.type, activeColor.hex);
  if (label) label.innerText = activeColor.name;

  setProductColor(quickViewActiveId, idx);
  openQuickView(quickViewActiveId);
}

function setQVSize(sz) {
  selectedSize = sz;
  ['S', 'M', 'L', 'XL'].forEach(s => {
    const btn = document.getElementById(`qv-btn-${s}`);
    if (btn) {
      if (s === sz) {
        btn.className = 'py-2.5 border text-center transition-colors border-brand-dark bg-brand-dark text-white';
      } else {
        btn.className = 'py-2.5 border text-center transition-colors border-brand-border bg-white text-brand-textPrimary hover:border-black';
      }
    }
  });
}

function addCurrentQVToBag() {
  if (!quickViewActiveId) return;
  const prod = PRODUCTS[quickViewActiveId];
  const color = prod.colors[prod.currentColor];
  addToCart({
    id: prod.id,
    title: prod.title,
    price: prod.price,
    color: color.name,
    hex: color.hex,
    size: selectedSize,
    type: prod.type,
    quantity: 1
  });
  closeQuickView();
}

function closeQuickView() {
  const backdrop = document.getElementById('quickview-backdrop');
  const panel = document.getElementById('quickview-panel');
  if (backdrop && panel) {
    backdrop.classList.remove('opacity-100');
    backdrop.classList.add('opacity-0', 'pointer-events-none');
    panel.classList.remove('scale-100');
    panel.classList.add('scale-95');
  }
}

function quickAddFromCard(pid) {
  const prod = PRODUCTS[pid];
  if (!prod) return;
  const color = prod.colors[prod.currentColor];
  addToCart({
    id: prod.id,
    title: prod.title,
    price: prod.price,
    color: color.name,
    hex: color.hex,
    size: 'M',
    type: prod.type,
    quantity: 1
  });
}

function toggleCartDrawer(open) {
  const backdrop = document.getElementById('cart-drawer-backdrop');
  const panel = document.getElementById('cart-drawer-panel');
  if (!backdrop || !panel) return;

  if (open) {
    backdrop.classList.remove('opacity-0', 'pointer-events-none');
    backdrop.classList.add('opacity-100');
    panel.classList.remove('translate-x-full');
  } else {
    backdrop.classList.remove('opacity-100');
    backdrop.classList.add('opacity-0', 'pointer-events-none');
    panel.classList.add('translate-x-full');
  }
}

function addToCart(item) {
  const existing = cart.find(i => i.id === item.id && i.color === item.color && i.size === item.size);
  if (existing) {
    existing.quantity += item.quantity;
  } else {
    cart.push(item);
  }
  updateCartDisplay();
  toggleCartDrawer(true);
  showToast(`Added "${item.title}" to bag.`);
}

function changeCartQty(idx, delta) {
  if (cart[idx]) {
    cart[idx].quantity += delta;
    if (cart[idx].quantity <= 0) cart.splice(idx, 1);
  }
  updateCartDisplay();
}

function removeCartItem(idx) {
  if (cart[idx]) {
    cart.splice(idx, 1);
    updateCartDisplay();
  }
}

function updateCartDisplay() {
  const totalCount = cart.reduce((acc, i) => acc + i.quantity, 0);
  const subtotal = cart.reduce((acc, i) => acc + (i.price * i.quantity), 0);

  const headerBadge = document.getElementById('cart-counter-badge');
  const drawerCount = document.getElementById('drawer-item-count');
  const subtotalEl = document.getElementById('cart-subtotal');
  const shippingDiff = document.getElementById('shipping-tracker-diff');
  const shippingBar = document.getElementById('shipping-progress');
  const itemsContainer = document.getElementById('cart-items-container');

  if (headerBadge) headerBadge.innerText = `(${totalCount})`;
  if (drawerCount) drawerCount.innerText = `(${totalCount})`;
  if (subtotalEl) subtotalEl.innerText = `$${subtotal.toFixed(2)}`;

  if (shippingDiff && shippingBar) {
    if (subtotal >= 75) {
      shippingDiff.innerText = 'Free Shipping Unlocked!';
      shippingDiff.className = 'text-emerald-700 font-semibold';
      shippingBar.style.width = '100%';
    } else {
      const diff = (75 - subtotal).toFixed(2);
      shippingDiff.innerText = `Add $${diff} more`;
      shippingDiff.className = 'text-brand-terracotta font-semibold';
      const pct = Math.min(100, Math.max(5, (subtotal / 75) * 100));
      shippingBar.style.width = `${pct}%`;
    }
  }

  if (!itemsContainer) return;
  if (cart.length === 0) {
    itemsContainer.innerHTML = `
      <div class="py-16 text-center text-brand-textMuted">
        <p class="font-serif text-xl text-brand-textPrimary mb-1">Your bag is empty.</p>
        <p class="text-xs">Explore our foundational quiet luxury collection.</p>
        <button onclick="toggleCartDrawer(false)" class="mt-6 text-xs uppercase tracking-widest bg-brand-dark text-white px-6 py-3 font-medium">
          EXPLORE COLLECTION
        </button>
      </div>
    `;
    return;
  }

  itemsContainer.innerHTML = cart.map((item, index) => `
    <div class="flex space-x-4 border-b border-brand-border/60 pb-5">
      <div class="w-16 h-20 bg-[#ECE6DC] p-2 flex items-center justify-center flex-shrink-0">
        ${generateGarmentSVG(item.type, item.hex)}
      </div>
      <div class="flex-1 flex flex-col justify-between">
        <div>
          <div class="flex justify-between items-start">
            <h4 class="text-xs font-medium text-brand-textPrimary">${item.title}</h4>
            <button onclick="removeCartItem(${index})" class="text-stone-400 hover:text-brand-terracotta text-sm">&times;</button>
          </div>
          <p class="text-[11px] text-brand-textMuted mt-0.5">${item.color} / Size ${item.size}</p>
          <p class="text-xs font-semibold text-brand-textPrimary mt-1">$${item.price}</p>
        </div>
        <div class="flex items-center space-x-3 mt-2">
          <div class="flex items-center border border-brand-border bg-white px-2 py-0.5">
            <button onclick="changeCartQty(${index}, -1)" class="text-xs px-1 hover:text-brand-terracotta">-</button>
            <span class="text-xs px-2 font-medium">${item.quantity}</span>
            <button onclick="changeCartQty(${index}, 1)" class="text-xs px-1 hover:text-brand-terracotta">+</button>
          </div>
        </div>
      </div>
    </div>
  `).join('');
}

function openStoryModal() {
  const el = document.getElementById('story-modal');
  if (el) {
    el.classList.remove('opacity-0', 'pointer-events-none');
    el.classList.add('opacity-100');
  }
}

function closeStoryModal() {
  const el = document.getElementById('story-modal');
  if (el) {
    el.classList.remove('opacity-100');
    el.classList.add('opacity-0', 'pointer-events-none');
  }
}

function toggleSearchModal(open) {
  const el = document.getElementById('search-modal');
  const input = document.getElementById('search-input');
  if (!el) return;
  if (open) {
    el.classList.remove('opacity-0', 'pointer-events-none');
    el.classList.add('opacity-100');
    if (input) input.focus();
  } else {
    el.classList.remove('opacity-100');
    el.classList.add('opacity-0', 'pointer-events-none');
  }
}

function handleSearch(q) {
  const res = document.getElementById('search-results');
  if (!res) return;
  const query = q.trim().toLowerCase();
  if (!query) {
    res.innerHTML = `<p class="text-xs text-brand-textMuted italic">Try searching "Mountain Essential" or "Crewneck"</p>`;
    return;
  }
  const list = Object.values(PRODUCTS).filter(p => p.title.toLowerCase().includes(query));
  if (list.length === 0) {
    res.innerHTML = `<p class="text-xs text-brand-textMuted">No garments found matching "${q}".</p>`;
  } else {
    res.innerHTML = list.map(item => `
      <div onclick="toggleSearchModal(false); openQuickView('${item.id}')" class="flex items-center space-x-3 p-2 hover:bg-stone-200/70 cursor-pointer">
        <div class="w-8 h-10 bg-[#ECE6DC] flex items-center justify-center p-1">
          ${generateGarmentSVG(item.type, item.colors[0].hex)}
        </div>
        <div>
          <div class="text-xs font-semibold">${item.title}</div>
          <div class="text-[11px] text-brand-textMuted">$${item.price}</div>
        </div>
      </div>
    `).join('');
  }
}

function toggleMobileMenu(open) {
  const backdrop = document.getElementById('mobile-menu');
  const panel = document.getElementById('mobile-panel');
  if (!backdrop || !panel) return;
  if (open) {
    backdrop.classList.remove('opacity-0', 'pointer-events-none');
    backdrop.classList.add('opacity-100');
    panel.classList.remove('-translate-x-full');
  } else {
    backdrop.classList.remove('opacity-100');
    backdrop.classList.add('opacity-0', 'pointer-events-none');
    panel.classList.add('-translate-x-full');
  }
}

function showToast(msg) {
  const shelf = document.getElementById('toast-shelf');
  if (!shelf) return;
  const toast = document.createElement('div');
  toast.className = 'bg-brand-dark text-white text-xs px-4 py-3 shadow-2xl border border-stone-700 flex items-center space-x-2 transition-all transform duration-300 opacity-0 translate-y-2 pointer-events-auto';
  toast.innerHTML = `<span class="w-1.5 h-1.5 rounded-full bg-brand-terracotta"></span><span>${msg}</span>`;
  shelf.appendChild(toast);
  requestAnimationFrame(() => {
    toast.classList.remove('opacity-0', 'translate-y-2');
    toast.classList.add('opacity-100', 'translate-y-0');
  });
  setTimeout(() => {
    toast.classList.add('opacity-0', 'translate-y-2');
    setTimeout(() => toast.remove(), 300);
  }, 3500);
}

window.addEventListener('DOMContentLoaded', () => {
  renderProductGarments();

  cart.push({
    id: 'prod-1',
    title: 'Mountain Essential Long Sleeve Tee',
    price: 49,
    color: 'Natural Sand',
    hex: '#EFE9DF',
    size: 'M',
    type: 'long-sleeve',
    quantity: 1
  });
  updateCartDisplay();

  const cartBackdrop = document.getElementById('cart-drawer-backdrop');
  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', (e) => {
      if (e.target === cartBackdrop) toggleCartDrawer(false);
    });
  }

  const qvBackdrop = document.getElementById('quickview-backdrop');
  if (qvBackdrop) {
    qvBackdrop.addEventListener('click', (e) => {
      if (e.target === qvBackdrop) closeQuickView();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      toggleCartDrawer(false);
      closeQuickView();
      closeStoryModal();
      toggleSearchModal(false);
      toggleMobileMenu(false);
    }
  });
});
